import { useNavigate } from 'react-router-dom';
import { PropsWithClassName } from '../../../types/PropsWithClassName';

interface HeaderProps extends PropsWithClassName {
  title?: string;
  backUrl?: string;
  rightContent?: React.ReactNode;
}

export const Header = ({ 
  title, 
  backUrl = '', 
  rightContent,
  className = ''
}: HeaderProps) => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    if (backUrl) {
      navigate(backUrl);
    } else {
      navigate(-1);
    }
  };

  return (
    <div className={`bg-white rounded-2xl px-6 print:hidden font-bold shadow-assessment-sm ${className}`}>
      <div className="mx-auto py-4">
        <div className="flex items-center justify-between">
          <button
            onClick={handleGoBack}
            className="bg-gray-800 text-white px-4 py-2 rounded-lg hover:bg-gray-700 transition-colors text-xl"
            aria-label="Go back"
          >
            ←
          </button>
          
          <div className="text-center flex items-center">
            <h1 className="mx-2 md:mx-0 text-lg md:text-2xl font-bold mr-2">{title}</h1>
          </div>

          {rightContent && (
            <div className="flex gap-2">
              {rightContent}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}; 